import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommThreeLinkedDotsIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M5 13.5C5.82843 13.5 6.5 12.8284 6.5 12 6.5 11.1716 5.82843 10.5 5 10.5 4.17157 10.5 3.5 11.1716 3.5 12 3.5 12.8284 4.17157 13.5 5 13.5zM5 15C6.65685 15 8 13.6569 8 12 8 10.3431 6.65685 9 5 9 3.34315 9 2 10.3431 2 12 2 13.6569 3.34315 15 5 15zM19 6.5C19.8284 6.5 20.5 5.82843 20.5 5 20.5 4.17157 19.8284 3.5 19 3.5 18.1716 3.5 17.5 4.17157 17.5 5 17.5 5.82843 18.1716 6.5 19 6.5zM19 8C20.6569 8 22 6.65685 22 5 22 3.34315 20.6569 2 19 2 17.3431 2 16 3.34315 16 5 16 6.65685 17.3431 8 19 8zM19 20.5C19.8284 20.5 20.5 19.8284 20.5 19 20.5 18.1716 19.8284 17.5 19 17.5 18.1716 17.5 17.5 18.1716 17.5 19 17.5 19.8284 18.1716 20.5 19 20.5zM19 22C20.6569 22 22 20.6569 22 19 22 17.3431 20.6569 16 19 16 17.3431 16 16 17.3431 16 19 16 20.6569 17.3431 22 19 22z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M8.45774 12L17.3859 17.3569L16.6141 18.6431L6.61413 12.6431V11.3569L16.6141 5.35688L17.3859 6.64312L8.45774 12Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
